import { CubeLut } from "./lut";

export interface LutHistoryItem {
  id: string;
  title: string;
  fileName: string;
  fileSize: number;
  dimension: number;
  entries: number;
  sourceText: string;
  createdAt: number;
}

const dbName = "spectracam-lut-lab";
const storeName = "lut-history";
const maxItems = 12;

export async function listLutHistory(): Promise<LutHistoryItem[]> {
  const db = await openHistoryDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(storeName, "readonly");
    const request = tx.objectStore(storeName).getAll();
    request.onsuccess = () => {
      const items = request.result as LutHistoryItem[];
      resolve(items.sort((a, b) => b.createdAt - a.createdAt));
    };
    request.onerror = () => reject(request.error);
  });
}

export async function saveLutHistoryItem(lut: CubeLut, sourceText: string): Promise<LutHistoryItem[]> {
  const item: LutHistoryItem = {
    id: `${lut.fileName}-${lut.fileSize}-${Date.now()}`,
    title: lut.title,
    fileName: lut.fileName,
    fileSize: lut.fileSize,
    dimension: lut.dimension,
    entries: lut.entries,
    sourceText,
    createdAt: Date.now()
  };

  const existing = await listLutHistory();
  const deduped = existing.filter((entry) => entry.fileName !== lut.fileName || entry.fileSize !== lut.fileSize);
  const nextItems = [item, ...deduped].slice(0, maxItems);
  const db = await openHistoryDb();

  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(storeName, "readwrite");
    const store = tx.objectStore(storeName);
    store.clear();
    for (const nextItem of nextItems) {
      store.put(nextItem);
    }
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });

  return nextItems;
}

export async function clearLutHistory(): Promise<void> {
  const db = await openHistoryDb();
  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(storeName, "readwrite");
    tx.objectStore(storeName).clear();
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

function openHistoryDb(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(dbName, 1);
    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(storeName)) {
        db.createObjectStore(storeName, { keyPath: "id" });
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}
